import {
  Box,
  Card,
  CardContent,
  Grid,
  Link,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../components/Button/Button";
import { Fragment } from "react/jsx-runtime";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ViewIcon from "../../../../../assets/images/icons/view.svg";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import API from "../../../../api/axios";
import moment from "moment";
import { ContentCopy } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { setToast } from "../../../../store/slices/toastSlice";
import { handleDate } from "../../../../shared/CommonFunctions/CommonFunction";

const breadcrumbs: BreadcrumbsModel[] = [
  {
    name: "Interview tracker",
    route: "/admin/interviewer/interview-tracker",
  },
  { name: "Upcoming Interview" },
];

const InterviewTrackerView = () => {
  const [interviewerInfo, setInterviewerInfo] = useState<any>({});

  const navigate = useNavigate();
  const state = useLocation();
  const dispatch=useDispatch();

  useEffect(() => {
    setInterviewerInfo(state?.state);
  }, []);

  const handleCopy = (link:any) => {
    navigator.clipboard.writeText(link);
     dispatch(
                setToast({
                  message: "Link copied to clipboard",
                  severity: "success",
                  open: true,
                })
              )
  };
  return (
    <PageWrapper>
      <PageHeader breadcrumbs={breadcrumbs} title="Upcoming Interview">
        <Button
          variant="secondary"
          variantType="contained"
          label="Back"
          onClick={() =>
            navigate("/admin/interviewer/interview-tracker", {
              state: state?.state,
            })
          }
        />
      </PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Position Title</Typography>
              <Typography variant="subtitle2">
                {interviewerInfo?.position_name || "NA"}
              </Typography>
            </Grid>
            <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Position Status</Typography>
              <Typography variant="subtitle2">
                {interviewerInfo?.application_id?.application_display_status || "NA"}
              </Typography>
            </Grid>
            <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Applied Date</Typography>
              <Typography variant="subtitle2">
                {handleDate(interviewerInfo?.application_id?.application_date)}
              </Typography>
            </Grid>
            {/* <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Invite Title</Typography>
              <Typography variant="subtitle2">HR Round static</Typography>
            </Grid> */}
            <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Interview Date</Typography>
              <Typography variant="subtitle2">
                {handleDate(interviewerInfo?.slot_date)}
              </Typography>
            </Grid>
            <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Interview Time</Typography>
              <Typography variant="subtitle2">
                {moment(interviewerInfo?.start_time, "HH:mm:ss").format(
                  "hh:mm A"
                ) || "NA"}{" "}
                -{" "}
                {moment(interviewerInfo?.end_time, "HH:mm:ss").format(
                  "hh:mm A"
                ) || "NA"}
              </Typography>
            </Grid>
            <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Interview Link</Typography>
              <Typography variant="subtitle2">
              {interviewerInfo?.webex_link ? (
                              <Box>
                              <Tooltip title="Click here to join the meeting">
                                <Link
                                  href={interviewerInfo?.webex_link}
                                  target="_blank"
                                  rel="noopener"
                                  underline="none"
                                  sx={{ whiteSpace: "nowrap" }}
                                >
                                  Interview Link{" "}
                                  </Link>
                              </Tooltip>
                                  <Tooltip title="Copy to clipboard">
                                    <IconButton
                                      onClick={() => {
                                        handleCopy(interviewerInfo?.webex_link);
                                      }}
                                      aria-label="copy link"
                                    >
                                      <ContentCopy  fontSize="small"/>
                                    </IconButton>
                                  </Tooltip>
                                  </Box>
                            ) : (
                              "NA"
                            )}
              </Typography>
            </Grid>
            {/* <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Panel Name</Typography>
              <Typography variant="subtitle2">
              </Typography>
            </Grid> */}
            <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Candidate Name</Typography>
              <Typography variant="subtitle2">
                {interviewerInfo?.candidate_name || "NA"}
              </Typography>
            </Grid>
            {/* <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Email</Typography>
              <Typography variant="subtitle2">
                vikramkhanna@gmail.com
              </Typography>
            </Grid>
            <Grid item xs={2.4} marginBottom={4}>
              <Typography variant="body1">Mobile</Typography>
              <Typography variant="subtitle2">9988990099</Typography>
            </Grid> */}
          </Grid>
        </CardContent>
      </Card>
    </PageWrapper>
  );
};
export default InterviewTrackerView;
